import React, { useState, useEffect } from "react";

import "./_ProductList.scss";
import "./_ProductListMobile.scss";
import ProductRow from "./_ProductRow";
import { useMediaQuery } from "react-responsive";

function _ProductList({
  setActivePanel,
  setEditIndex,
  editIndex,
  searchKeyword,
}) {
  const [products, setProducts] = useState([]);
  const [checked, setChecked] = useState([]);
  const [reloadList, setReloadList] = useState(false);
  const [productTypeFilter, setProductTypeFilter] = useState("ALL");
  const [flagFilter, setFlagFilter] = useState("ALL");

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_BASE_URL}api/product/get-all-products-admin`,
      {
        credentials: "include",
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setProducts(data.product || []);
      })
      .catch((err) => {
        console.error("Error fetching products:", err);
      });
    setReloadList(false);
  }, [reloadList]);

  // Update checked state if products change
  useEffect(() => {
    setChecked(products.map(() => false));
  }, [products]);

  const [foreign, setForeign] = useState({
    animeSeries: [],
    manufacturers: [],
    categories: [],
  });

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}api/product/get-foreign`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((foreign) => {
        setForeign(foreign);
      })
      .catch((err) => {
        console.error("Error fetching foreign data:", err);
      });
  }, []);

  const handleCheckAll = (e) => {
    setChecked(products.map(() => e.target.checked));
  };
  const filteredProducts = products.filter((p) => {
    const keyword = searchKeyword.toLowerCase();

    // 🔹 Text search filter
    const matchesKeyword =
      p.PD_Name.toLowerCase().includes(keyword) ||
      p.PD_ProductType.toLowerCase().includes(keyword) ||
      String(p.PD_OriginalPrice).includes(keyword);

    // 🔹 Product type filter
    const matchesProductType =
      productTypeFilter === "ALL" ||
      (productTypeFilter === "ON HAND" && p.PD_ProductType === "onhand") ||
      (productTypeFilter === "PRE ORDER" && p.PD_ProductType === "preorder");

    // 🔹 Flag filter
    const matchesFlag =
      flagFilter === "ALL" ||
      (flagFilter === "MOST POP" && p.PD_IsMostPop) ||
      (flagFilter === "NEW ARRIVAL" && p.PD_IsNewArrival) ||
      (flagFilter === "ON HAND" && p.PD_IsOnhand) ||
      (flagFilter === "PRE ORDER" && p.PD_IsPreOrder);

    return matchesKeyword && matchesProductType && matchesFlag;
  });

  const handleCheckRow = (index) => (e) => {
    const newChecked = [...checked];
    newChecked[index] = e.target.checked;
    setChecked(newChecked);
  };

  const allChecked = checked.length > 0 && checked.every(Boolean);

  const isMobile = useMediaQuery({ maxWidth: 600 });

  if (!isMobile) {
    return (
      <>
        <div className="prod-panel-table-wrapper">
          <table>
            <thead>
              <tr>
                <th></th>
                {/** 
              <th>
                <input
                  type="checkbox"
                  checked={allChecked}
                  onChange={handleCheckAll}
                />
              </th>*/}
                <th>Photo</th>
                <th>Product Name</th>
                <th>Price </th>
                <th>
                  Product Type
                  <br />
                  <select
                    className="th-select-product-type"
                    value={productTypeFilter}
                    onChange={(e) => setProductTypeFilter(e.target.value)}
                  >
                    <option>ALL</option>
                    <option>ON HAND</option>
                    <option>PRE ORDER</option>
                  </select>
                </th>
                <th>No. of Sales</th>
                <th>
                  FLAGS <br />
                  <select
                    className="th-select-product-type"
                    value={flagFilter}
                    onChange={(e) => setFlagFilter(e.target.value)}
                  >
                    <option>ALL</option>
                    <option>MOST POP</option>
                    <option>NEW ARRIVAL</option>
                    <option>ON HAND</option>
                    <option>PRE ORDER</option>
                  </select>
                </th>
                <th>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {filteredProducts.length === 0 ? (
                <tr>
                  <td
                    colSpan="8"
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    No products found.
                  </td>
                </tr>
              ) : (
                filteredProducts.map((p, i) => (
                  <ProductRow
                    key={i}
                    product={p}
                    checked={checked[i]}
                    foreign={foreign}
                    onCheck={handleCheckRow(i)}
                    setActivePanel={setActivePanel}
                    setEditIndex={setEditIndex}
                    editIndex={editIndex}
                    setReloadList={setReloadList}
                  />
                ))
              )}
            </tbody>
          </table>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="prod-panel-table-wrapper">
          <table>
            <thead>
              <tr>
                <th></th>
                {/** 
              <th>
                <input
                  type="checkbox"
                  checked={allChecked}
                  onChange={handleCheckAll}
                />
              </th>*/}
                <th>Photo</th>
                <th>Product Name</th>
                <th>
                  Product Type
                  <br />
                  <select
                    className="th-select-product-type"
                    value={productTypeFilter}
                    onChange={(e) => setProductTypeFilter(e.target.value)}
                  >
                    <option>ALL</option>
                    <option>ON HAND</option>
                    <option>PRE ORDER</option>
                  </select>
                </th>
                <th>
                  FLAGS <br />
                  <select
                    className="th-select-product-type"
                    value={flagFilter}
                    onChange={(e) => setFlagFilter(e.target.value)}
                  >
                    <option>ALL</option>
                    <option>MOST POP</option>
                    <option>NEW ARRIVAL</option>
                    <option>ON HAND</option>
                    <option>PRE ORDER</option>
                  </select>
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredProducts.length === 0 ? (
                <tr>
                  <td
                    colSpan="8"
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    No products found.
                  </td>
                </tr>
              ) : (
                filteredProducts.map((p, i) => (
                  <ProductRow
                    key={i}
                    product={p}
                    checked={checked[i]}
                    foreign={foreign}
                    onCheck={handleCheckRow(i)}
                    setActivePanel={setActivePanel}
                    setEditIndex={setEditIndex}
                    editIndex={editIndex}
                    setReloadList={setReloadList}
                  />
                ))
              )}
            </tbody>
          </table>
        </div>
      </>
    );
  }
}

export default _ProductList;
